module.exports = __webpack_public_path__ + "static/media/hrimg.6a534a84.svg";